import styled from 'styled-components';

const Container = styled.div`
  margin: 0 auto 50px auto;

  .slick-prev,
  .slick-next {
    z-index: 1;
    display: flex !important;
    background: white;
    height: 60px;
    width: 60px;
    justify-content: center;
    border-radius: 50%;
    align-items: center;
    bottom: -50px;
    top: auto;

    svg {
      width: 22px;
      height: auto;
    }

    &:before {
      content: '';
    }

    &:hover {
      box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.25);
    }
  }

  .slick-prev {
    left: 0px;
  }

  .slick-next {
    right: 0px;
  }

  .slick-dots {
    bottom: 0px;
  }

  .slick-dots li.slick-active button {
    &:before {
      color: var(--blue-5);
      opacity: 1;
    }
  }

  .slick-dots li button {
    &:before {
      font-size: 10px;
    }
    &:hover {
      &:before {
        color: var(--blue-5);
        opacity: 0.85;
      }
    }
  }

  .slick-prev {
    left: 30%;
  }

  .slick-next {
    right: 30%;
  }

  @media (max-width: 1000px) {
    .slick-prev {
      left: 25%;
    }

    .slick-next {
      right: 25%;
    }
  }

  ${({ includesFullWidthBackground }) => {
    if (includesFullWidthBackground) {
      return `
        .row-container--container {
          padding-bottom: 190px;
        }

        .slick-prev, .slick-next {
          bottom: 40px;
        }

        .slick-dots {
          bottom: 85px;
        }
      `;
    }
  }}

  @media (max-width: 768px) {
    .slick-dots {
      bottom: 10px;
    }

    .slick-prev,
    .slick-next {
      height: 40px;
      width: 40px;
      bottom: -20px;

      img {
        height: 40px;
        width: 40px;
      }
    }

    .slick-prev {
      left: 25px;
    }

    .slick-next {
      right: 25px;
    }

    ${({ includesFullWidthBackground }) => {
      if (includesFullWidthBackground) {
        return `
        .row-container--container {
          padding-bottom: 140px;
        }

        .slick-prev, .slick-next {
          bottom: 40px;
        }

        .slick-dots {
          bottom: 67px;
        }
      `;
      }
    }}
  }
`;

export { Container };
